import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import {ICountriesPayload, IGendersPayload, IHeaderInitialState} from "../types";


const initialState: IHeaderInitialState = {
    isMood: false,
    isScreenWide: window.innerWidth > 575,
    clickedRowKey: null,
    themeMode: "light",
    countries: [],
    filterCountries: [],
    genders: [],
    regions: [],
    residenceRegions: []
}

export const headerSlice = createSlice({
    name: "header",
    initialState,
    reducers: {
        changeMood: (state) => {
            state.isMood = !state.isMood
            state.themeMode = state.isMood ? "dark" : "light";
        },

        setIsScreenWide: (state, action) => {
            state.isScreenWide = action.payload
        },
        setClickedRowKey: (state, action) => {
            state.clickedRowKey = action.payload;
        },

        setGenders: (state, action: PayloadAction<{ data: IGendersPayload[], defaultLanguage: string }>) => {
            const {data} = action.payload;
            state.genders = data
        },
        setCountries: (state, action: PayloadAction<{ data: ICountriesPayload[], defaultLanguage: string }>) => {
            const {data, defaultLanguage} = action.payload;
            state.countries = data
            state.filterCountries = data.flatMap(
                (data) =>
                    data.translations
                        .filter((elem) => elem.slug === defaultLanguage && elem.name)
                        .map((elem) => ({
                            id: data.id,
                            name: elem.name as string,
                        }))
            );

        },
        setFilteredCountry: (state, action: PayloadAction<{ selectedLanguage: string }>) => {
            const {selectedLanguage} = action.payload;

            state.filterCountries = state.countries.flatMap(
                (data) =>
                    data.translations
                        .filter((elem) => elem.slug === selectedLanguage && elem.name)
                        .map((elem) => ({
                            id: data.id,
                            name: elem.name as string,

                        }))
            );

        },

        setSelectedRegions: (state, action: PayloadAction<{ id: number; defaultLanguage: string }>) => {
            const {id} = action.payload;
            const selectedCountry = state.countries.find(country => country.id === id);
            if (!selectedCountry) {
                state.regions = [];
                return;
            }

            state.regions = selectedCountry.regions

        },
        setSelectedResidenceRegions: (state, action: PayloadAction<{ id: number; defaultLanguage: string }>) => {
            const {id} = action.payload;
            const selectedCountry = state.countries.find(country => country.id === id);
            if (!selectedCountry) {
                state.residenceRegions = [];
                return;
            }
            state.residenceRegions = selectedCountry.regions
        },
        logOut: (state) => {
            localStorage.clear()
            state.isMood = false;
            Cookies.remove("token");
        },

    }
})
export const {
    changeMood,
    logOut,
    setIsScreenWide,
    setClickedRowKey,
    setSelectedResidenceRegions,
    setFilteredCountry,
    setSelectedRegions,
    setGenders,
    setCountries

} = headerSlice.actions;